/* @flow */
export type SetpointProps = {
  setpointCool: ?number,
  setpointCoolMax: ?number,
  setpointCoolMin: ?number,
  setpointDelta: number,
  setpointHeat: ?number,
  setpointHeatMax: ?number,
  setpointHeatMin: ?number,
};

type SetpointsState = {
  setpointHeat?: number,
  setpointCool?: number,
};
export function updateHeatSetpoint(
  info: SetpointProps,
  targetHeatSetpoint: number
): SetpointsState {
  const nextState = {};

  const clampedHeatSetpoint = clampHeatSetpoint(info, targetHeatSetpoint);
  nextState.setpointHeat = clampedHeatSetpoint;

  if (getMode(info) === "auto") {
    if (info.setpointCool == null) {
      return nextState; // for Flow
    }
    const setpointDifference = info.setpointCool - clampedHeatSetpoint;
    if (setpointDifference < info.setpointDelta) {
      const necessaryAdjustment = info.setpointDelta - setpointDifference;
      const targetCoolsetpoint = info.setpointCool + necessaryAdjustment;
      const clampedCoolSetpoint = clampCoolSetpoint(info, targetCoolsetpoint);
      nextState.setpointCool = clampedCoolSetpoint;
    }
  }
  return nextState;
}

export function updateCoolSetpoint(
  info: SetpointProps,
  targetCoolSetpoint: number
): SetpointsState {
  const nextState = {};

  const clampedCoolSetpoint = clampCoolSetpoint(info, targetCoolSetpoint);
  nextState.setpointCool = clampedCoolSetpoint;

  if (getMode(info) === "auto") {
    if (info.setpointHeat == null) {
      return nextState; // for Flow
    }
    const setpointDifference = clampedCoolSetpoint - info.setpointHeat;
    if (setpointDifference < info.setpointDelta) {
      const necessaryAdjustment = info.setpointDelta - setpointDifference;
      const targetHeatSetpoint = info.setpointHeat - necessaryAdjustment;
      const clampedHeatValue = clampHeatSetpoint(info, targetHeatSetpoint);
      nextState.setpointHeat = clampedHeatValue;
    }
  }
  return nextState;
}

function getMode(info: SetpointProps): string {
  const { setpointHeat, setpointCool } = info;

  if (setpointHeat && !setpointCool) {
    return "heat";
  } else if (setpointCool && !setpointHeat) {
    return "cool";
  } else if (setpointCool && setpointHeat) {
    return "auto";
  } else {
    return "off";
  }
}

function clampCoolSetpoint(info: SetpointProps, value: number): number {
  const min = info.setpointCoolMin || value;
  const max = info.setpointCoolMax || value;
  return Math.max(min, Math.min(max, value));
}

function clampHeatSetpoint(info: SetpointProps, value: number): number {
  const min = info.setpointHeatMin || value;
  const max = info.setpointHeatMax || value;
  return Math.max(min, Math.min(max, value));
}



// WEBPACK FOOTER //
// ../nx-components/src/Thermostat/calculateSetpoint.js